module.exports = __webpack_public_path__ + "img/k1_tip_ico.bee360ea.png";